import React, { useState } from 'react';
import './index.scss';

export interface IEmailSelectInputProps {
  datasource: Array<{ id: string }>;
  placeholder?: string;
  onChange?: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  value?: string;
  id?: string;
  disabled?: boolean;
}

const EmailSelectInput: React.FC<IEmailSelectInputProps> = ({
  datasource,
  placeholder = 'Select an account...',
  onChange,
  value,
  id,
  disabled = false,
}) => {
  const [selectedEmail, setSelectedEmail] = useState(value || '');

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedEmail(e.target.value);
    if (onChange) onChange(e); // Pass the event object
  };

  return (
    <div className="email-select-input">
      <select id={id} value={selectedEmail} onChange={handleChange} className="email-select" disabled={disabled}>
        <option value="" disabled>
          {placeholder}
        </option>
        {datasource.map((user, ix) => (
          <option key={ix} value={user.id}>
            {user.id}
          </option>
        ))}
      </select>
    </div>
  );
};

export default EmailSelectInput;
